// 내부 IP(헬스체크/LB 등) 또는 로컬 접속 — public-info 404(ERR-1201) 반복 호출을 막기 위해 회사 URL로 넘기지 않는다.
const INTERNAL_ORIGIN_REGEX =
  /^https?:\/\/(localhost|127\.\d+\.\d+\.\d+|10\.\d+\.\d+\.\d+|192\.168\.\d+\.\d+|172\.(?:1[6-9]|2\d|3[01])\.\d+\.\d+|169\.254\.\d+\.\d+)(?::\d+)?$/

const isInternalOrigin = (origin: string | null | undefined) =>
  !origin || INTERNAL_ORIGIN_REGEX.test(origin)

/**
 * 회사 식별용 URL을 결정한다.
 * 실제 접속 origin을 우선 사용하고, origin이 없거나 내부 IP/로컬인 경우에만
 * NEXT_PUBLIC_COMPANY_URL 고정값으로 대체한다. 내부 IP(헬스체크/LB)는
 * public-info를 호출하지 않아 404 반복 호출을 막는다.
 */
export const resolveCompanyUrl = (origin: string | null | undefined): string => {
  if (!isInternalOrigin(origin)) {
    return origin as string
  }
  return process.env.NEXT_PUBLIC_COMPANY_URL || ''
}
